import { CKButton } from '@clearkit/react';
import get from 'lodash/get';
import { Link } from 'react-router-dom';

import { destinationNameForType } from '~/lib/destinations';
import paths from '~/lib/paths';
import EnabledSwitch from '~/pages/destinations/components/EnabledSwitch';
import Logo from '~/pages/destinations/components/Logo';

import { description, timePeriod } from '../utils';
import styles from './styles';

const Destination = ({
  destination,
  classes,
  slackAccountConnector,
  loading,
  className,
  segment,
}) => {
  return (
    <li
      className={classnames(className, classes.destination, {
        [classes.destinationLoading]: loading,
      })}
      key={destination.id}>
      <div className={classes.destinationSwitchWrapper}>
        <EnabledSwitch
          disabled={!!loading}
          className={classes.destinationSwitch}
          destination={destination}
        />
      </div>
      <div className={classes.destinationDetailsWrapper}>
        <Logo
          className={classes.destinationLogo}
          destinationType={destination.type}
        />
        <div className={classes.destinationNameWrapper}>
          <span className={classes.destinationName}>
            {destinationNameForType(destination.type)}{' '}
          </span>

          <span className={classes.destinationDescription}>
            {!loading && (
              <>
                {description(destination, slackAccountConnector, classes)}{' '}
                {timePeriod(
                  get(destination, 'config.duplicateSuppressionTimeframe'),
                  segment?.type,
                )}
              </>
            )}
            &nbsp;
          </span>
        </div>
        <CKButton
          rel="configure-destination"
          className={classes.destinationButton}
          disabled={!!loading}
          as={Link}
          isSmall
          to={paths.segmentDestinationEdit(
            segment?.type,
            segment?.id,
            destination.id,
          )}>
          Configure
        </CKButton>
      </div>
    </li>
  );
};

Destination.propTypes = {
  loading: PropTypes.bool,
  classes: PropTypes.object,
  className: PropTypes.string,
  destination: PropTypes.object,
  slackAccountConnector: PropTypes.object,
  segment: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
  }),
};

export default withStyles(styles)(Destination);
